// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4562) return "static/chunks/0a492fc0-3e6240ab54a18621.js";
	if (chunkId === 6588) return "static/chunks/6588-6e4f4820891b36b2.js";
	if (chunkId === 1448) return "static/chunks/1448-6ff9ae3ab2e29ca6.js";
	if (chunkId === 4406) return "static/chunks/4406-4225aeab5f6437c3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"918":"3bb0228fd7bd819a","4009":"0d0fe1d2625fa659","5037":"085307acec01bb1f","5112":"8b91e5164295258a"}[chunkId] + ".js";
};